import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import TranslatedTitle from 'widgets/TranslatedTitle'
import * as Displays from 'support/displays'
import { WhenModel } from '@morningtrain/react-resources'
import * as UI from 'ui'

export default function SalaryOverviewTitle (props) {
  const subtitle = (
    <WhenModel>
      <span className='text-sm text-gray-500'>
        <Translation name='generic.period' />
        <span>: </span>
        <Displays.Date name='period_starts_at' /> - <Displays.Date name='period_ends_at' />
      </span>
    </WhenModel>
  )

  return (
    <UI.WithSubtitle subtitle={subtitle}>
      <TranslatedTitle {...props} />
    </UI.WithSubtitle>
  )
}

SalaryOverviewTitle.defaultProps = {
  ...Translation.defaultProps
}

SalaryOverviewTitle.propTypes = {
  ...Translation.propTypes
}
